'use client';

import type { Plan, PlanSku } from '@/app/actions/cart';
import { Button } from '@/components/ui/button';
import { SparklesIcon } from 'lucide-react';
import { motion } from 'motion/react';

interface TrialBannerProps {
  trialPlan: { plan: Plan; sku: PlanSku };
  showBanner: boolean;
  onBuy: () => void;
}

const TrialBanner = ({ trialPlan, showBanner, onBuy }: TrialBannerProps) => {
  if (!showBanner) return null;

  return (
    <motion.div
      className="flex items-center justify-center mb-12"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex items-center gap-4 rounded-2xl border border-primary bg-linear-to-r from-primary/5 to-primary/10 px-6 py-4 max-w-lg w-full">
        <SparklesIcon className="w-8 h-8 text-primary shrink-0" />
        <div className="flex-1 min-w-0">
          <h4 className="font-medium text-foreground">
            ¥{trialPlan.sku.sale_price / 100}体验
            {trialPlan.plan.name}
          </h4>
          <p className="text-sm text-muted-foreground">
            {trialPlan.sku.name} · 含{trialPlan.sku.point_amount}积分
            ,立即解锁全部高级功能
          </p>
        </div>
        <Button size="sm" variant="default" onClick={onBuy}>
          立即体验
        </Button>
      </div>
    </motion.div>
  );
};

export default TrialBanner;
